import styled from "styled-components";

export const TranslateError = styled.div`
  display: flex;
  align-items: center;
  color: #272560;
  opacity: 0.45;
  cursor: pointer;

  svg {
    margin-right: 5px;
  }

  &:hover {
    color: #605ce5;
    opacity: 1;
  }
`;
